import * as React from "react"
import {keyframes} from "@emotion/react"
import {Skeleton, useTheme} from "@mui/material"
import {TableSeeker} from "@ui-seeker/core"

import {isLoadingNewProducts, newProductsTableData} from "../@signals"
import {useUnmatchedNewProductsData} from "../@hooks"
import {actionsColumn, priceColumn, productRawColumn, retailerColumn} from "./columns"
import UnmatchedNewProductsTableToolbar from "./CustomToolbar"


export default function UnmatchedNewProductsTable() {

	const { palette } = useTheme()
    const { isEmpty } = useUnmatchedNewProductsData()

	if (isLoadingNewProducts.value) return <Skeleton variant="rectangular" height={500} sx={{ mt: 2 }} />
	if (!newProductsTableData.value.length && !isEmpty) return <></>
	
	return <TableSeeker
		data={newProductsTableData.value}
		title={'Unmatched New Products'}
		columns={[
			...retailerColumn(),
			...productRawColumn(),
			priceColumn(),
			actionsColumn()
		]}
		options={{
			selectableRows: 'multiple',
			customToolbarSelect: (selectedData, setSelectedRows) => <UnmatchedNewProductsTableToolbar
				selectedData={selectedData}
				setSelectedRows={setSelectedRows}
			/>,
			enhancedSetRowProps: () => ({ sx: {
				"&:has(.is-loading)": {
					animation: `${keyframes({
						"0%": { backgroundColor: palette.info.light },
						"100%": { backgroundColor: palette.info.lighter }
					})} 1s linear infinite alternate`
				},
				"&:has(.is-open)": {backgroundColor: "warning.light"}
			} })
		}}
        textLabels= {{
			body: {
				noMatch: 'No new products found for the selected filters.',
			}
		}}
	/>
}